import { batch } from 'react-redux';
import { useAppDispatch, useAppSelector } from 'redux/reduxHooks';
import { STEPS, popFamilyStep, pushFamilyStep, resetFBCached, resetStep2ContactPatient, setContactUser, updateFBCached, updatePatients } from 'redux/familyBookingSlice';
import { getFamilyBookingPatientsAPI } from 'services/APIs';
import { formatDobForBE } from 'components/BookingForm/utils/helperFunction';
import { loadOtpToken, saveOtpToken } from 'utils/storage';
import VerificationInput from './VerificationInput/VerificationInput';
import { renderToast } from 'components/CustomToast/CustomToast';

const { SIGN_UP, CONTACT_DETAILS, SCHEDULE } = STEPS;

const VERIFICATION_ERROR_MESSAGE =
  'Something went wrong. Please try again later';

const Verification = () => {
  const {
    familyBookingSlice: {
      step1: { dob: dobStep1, phoneNumber: phoneNumberStep1 },
      step2: { signUp },
      stepStack,
      contactUser,
    },
    clinicDetailsSlice: { clinicData },
  } = useAppSelector((state) => state);
  const previousPage = stepStack[stepStack.length - 2];

  const isSignUpIdentity = previousPage === SIGN_UP;

  const isReverifiedContact = previousPage === CONTACT_DETAILS;

  const dob = isSignUpIdentity ? signUp.dob : dobStep1;

  const phoneNumber = isSignUpIdentity ? signUp.phoneNumber : phoneNumberStep1;

  const dispatch = useAppDispatch();

  const handleOnBackClick = () => {
    batch(() => {
      dispatch(resetFBCached());
      dispatch(popFamilyStep());

      // Re-verification sits on top of the contact details the user already
      // completed, so Back has to clear both to reach the lookup step.
      if (isReverifiedContact) {
        dispatch(popFamilyStep());
      }
    });
  };

  const handleCheckOtpSuccessful = async (otpAccessToken: string) => {
    saveOtpToken(otpAccessToken, phoneNumber);

    if (isSignUpIdentity) {
      return batch(() => {
        dispatch(pushFamilyStep(SCHEDULE));
        dispatch(updateFBCached({ phoneNumber, dob }));
      });
    }

    try {
      const formatDob = formatDobForBE(dob);

      const patients = await getFamilyBookingPatientsAPI(
        {
          clinicId: clinicData.id,
          dob: formatDob,
          phoneNumber,
        },
        {
          otpToken: loadOtpToken(phoneNumber),
        }
      );

      batch(() => {
        dispatch(updatePatients(patients));
        dispatch(updateFBCached({ phoneNumber, dob }));

        if (isReverifiedContact) {
          dispatch(setContactUser(contactUser));
          dispatch(pushFamilyStep(SCHEDULE));

          return;
        }

        dispatch(resetStep2ContactPatient());
        dispatch(pushFamilyStep(CONTACT_DETAILS));
      });
    } catch (error) {
      renderToast({ message: VERIFICATION_ERROR_MESSAGE });
    }
  };

  return (
    <VerificationInput
      onBackClick={handleOnBackClick}
      phoneNumber={phoneNumber}
      onCheckedOtpSuccessful={handleCheckOtpSuccessful}
    />
  );
};

export default Verification;
